import * as React from 'react';
import { ColumnProps } from 'primereact/column';
import { User } from '../../../../settings/users/models/User';
import { ProjectDocFolderCUser } from '../../../../workflows/models/ProjectDocFolderCUser';
import { EditorColumnProps } from './EditorColumnProps';
import { UserSearchAutoComplete } from './UserSearchAutoComplete';
import { resolveFieldData } from '../../../../../helpers/utils/FieldDataResolver';

export function TitleBodyExt(row: ProjectDocFolderCUser, col: any) {
  return row?.User ? `${row.User.Title}` : "";
}

const TitleBody: React.FC<EditorColumnProps> = ({ row, col, getEditable, onUpdate }) => {
  const [searchUser, setSearchUser] = React.useState<User>();
  const editable = React.useMemo(() => getEditable(row), [getEditable, row]);
  React.useEffect(() => {
    setSearchUser(resolveFieldData(row, "User"));
  }, [getEditable, row]);

  const onChange = (user: User) => {
    setSearchUser(user);
    onUpdate({
      ...row,
      User: user,
      UserId: user?.Id || 0
    });
  };

  return getEditable(row)
    ? (<UserSearchAutoComplete searchUser={searchUser} onChange={onChange} field={`Title`} />)
    : (<span>{TitleBodyExt(row, col.field)}</span>);
}

export function ApproverTitleColumn(getEditable: (row: ProjectDocFolderCUser) => boolean, onUpdate: (row: ProjectDocFolderCUser) => void): ColumnProps {
  return {
    body: (row: ProjectDocFolderCUser, col: any) => <TitleBody row={row} col={col} getEditable={getEditable} onUpdate={onUpdate} />
  };
}

